import { render, staticRenderFns } from "./PrimeCostsList.vue?vue&type=template&id=1a234827&scoped=true&"
import script from "./PrimeCostsList.vue?vue&type=script&lang=ts&"
export * from "./PrimeCostsList.vue?vue&type=script&lang=ts&"
import style0 from "./PrimeCostsList.vue?vue&type=style&index=0&id=1a234827&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a234827",
  null
  
)

export default component.exports